import React, { useRef, useState } from 'react';
import { noop } from 'lodash';
import { LOGO_PROJECT_LISTINGS, DEFAULT_TARGET_TYPE } from '../../../propTypes';
import LoadMore from '../shared/LoadMore';
import { PROJECT_CARD_CLASSNAME, PROJECT_CARD_DOM_ID_ATTRIBUTE } from '../../cards/LogoProjectCard/constants';
import LogoProjectCard from '../../cards/LogoProjectCard';
import useImpressions from './hooks/useImpressions';
import { LOAD_MORE_BREAKPOINT } from './constants';
import classes from './index.module.scss';

const LogoProjectListings = ({
    projects = [],
    userSavings = [],
    loadMore,
    isMobile = false,
    isTablet = false,
    showUserSavings = false,
    brandName,
    slogan,
    impressionEnrichment,
    navigationParams,
    onUserSavingsChange = noop,
    onPreviewLoad = noop,
    onLogoProjectCardClick = noop,
    onLogoProjectArrowClick = noop,
    onLogoProjectHover = noop,
    onLogoProjectVariationHover = noop,
    onLoadMoreVariationsClick = noop,
    target = DEFAULT_TARGET_TYPE,
    skipChooseVariation = false,
    isLoading = false,
    banner,
    bannerRow
}) => {
    const gridRef = useRef(null);
    const items = projects.map((project) => ({
        project,
        userSaved: userSavings.find(({ project_id }) => project_id === project.id)
    }));

    const [loadMoreTriggerRef, setLoadMoreTriggerRef] = useState(useRef(null));
    const loadMoreTriggerIndex = (items.length - 1) - LOAD_MORE_BREAKPOINT;

    useImpressions({
        projects,
        impressionEnrichment,
        selector: `.${PROJECT_CARD_CLASSNAME}`,
        idAttribute: PROJECT_CARD_DOM_ID_ATTRIBUTE,
        containerRef: gridRef
    });

    const logoProjectCardEventHandlers = (logoPosition, project) => {
        const enrichment = { logoPosition, ...project };

        return {
            onPreviewLoad,
            onUserSavingChange: onUserSavingsChange,
            onLogoProjectCardClick: (params) => onLogoProjectCardClick({ ...params, ...enrichment }),
            onLogoProjectArrowClick: (params) => onLogoProjectArrowClick({ ...params, ...enrichment }),
            onLoadMoreVariationsClick: () => onLoadMoreVariationsClick(enrichment),
            onLogoProjectHover: (params) => onLogoProjectHover({ ...params, ...enrichment }),
            onLogoProjectVariationHover: (params) => onLogoProjectVariationHover({ ...params, ...enrichment })
        };
    };

    return (
        <div className={classes.listings}>
            <div className={classes.grid} ref={gridRef}>
                {banner && (
                    <div className={classes.bannerWrapper} style={{ gridRowStart: bannerRow }}>
                        {banner}
                    </div>
                )}
                {items.map(({ project, userSaved }, index) => (
                    <div key={project.id} className={classes.cardWrapper}>
                        <LogoProjectCard {...project}
                            {...(index === loadMoreTriggerIndex && ({ setTriggerRef: setLoadMoreTriggerRef }))}
                            {...logoProjectCardEventHandlers(index + 1, project)}
                            isMobile={isMobile}
                            isTablet={isTablet}
                            isLoading={isLoading}
                            brandName={brandName}
                            slogan={slogan}
                            navigationParams={navigationParams}
                            userSaved={userSaved}
                            showUserSaved={showUserSavings}
                            impressionEnrichment={impressionEnrichment}
                            skipChooseVariation={skipChooseVariation}
                            target={target}/>
                    </div>
                ))}
            </div>
            {loadMore && !isLoading && <LoadMore loadMore={loadMore} triggerRef={loadMoreTriggerRef} autoload={true}/>}
        </div>
    );
};

LogoProjectListings.propTypes = LOGO_PROJECT_LISTINGS;

export default React.memo(LogoProjectListings);
